module.exports = __webpack_public_path__ + "static/scale-model-of-florida-state-capitol-in-tallahassee-florida-8cce484bcab32b0091bff213494d5af4.png";